<div class="details" [class.is-open]="isOpen">
	<div class="summary">
		<div class="title" (click)="toggleDetails()">
			<ic-fa-icon [icon]="isOpen ? 'caret-down' : 'caret-right'" />
			<ng-content select="label, ic-tree-view-item-title" />
		</div>

		@if (isOpen) {
			<ng-content select=".summary-actions" />
		}
	</div>

	<div class="subtitle"><ng-content select="small" /></div>

	@if (isOpen) {
		<div class="detail-content"><ng-content select=".content" /></div>
	}
</div>
